import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import { getColorByIndex, getLightColorByIndex } from 'helpers'
import exitFullScreenIcon from 'images/icons/exit-full-screen.svg'
import fullScreenIcon from 'images/icons/full-screen.svg'
import productIcon from 'images/icons/product.svg'
import React from 'react'
import HomeIcon from '@material-ui/icons/Home'
import { Bar as BarChart } from 'react-chartjs-2'
import { Page, Toolbar } from 'react-onsenui'
import { appBar, filters, primaryColor } from '../Styles'
const StatsByGreenhouseScreen = props => {
  const getData = () => {
    return props.statsByProductAveragePrice
  }

  const getUnit = () => {
    return '€'
  }

  const isPeriodComparison = () => {
    return getData().length && getData()[0].period2 !== null
  }

  const getChartData = () => {
    const data = getData()
    const datasets = []

    datasets.push({
      label: isPeriodComparison() ? 'Periodo 1' : '',
      backgroundColor: isPeriodComparison() ? '#6F95D1' : data.map((val, i) => getColorByIndex(i)),
      data: data.map(val => val.period1),
    })

    if (isPeriodComparison()) {
      datasets.push({
        label: 'Periodo 2',
        backgroundColor: '#8ACA4C',
        data: data.map(val => val.period2),
      })
    }

    return {
      labels: data.map(val => val.name),
      datasets: datasets,
    }
  }

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Precio medio por producto</Typography>
          </div>
          <div className='right' >
            <HomeIcon onClick={() => props.goTo('home', {})} className={props.classes.goBackIcon} />
          </div>
        </Toolbar>
      )}>
      <div className={props.classes.filters}>
        <Grid item container>
          <Grid item xs={6} onClick={props.openPeriod1Modal} className={props.classes.filterPeriod1}>
            <Typography className={props.classes.filterName}>
              Periodo 1<KeyboardArrowDownIcon className={props.classes.icon} />
            </Typography>
            <Typography
              className={props.classes.filterValue}
              dangerouslySetInnerHTML={{ __html: props.period1Label }}
            />
          </Grid>
          <Grid item xs={6} onClick={props.openPeriod2Modal} className={props.classes.filterPeriod2}>
            <Typography className={props.classes.filterName}>
              Periodo 2<KeyboardArrowDownIcon className={props.classes.icon} />
            </Typography>
            <Typography
              className={props.classes.filterValue}
              dangerouslySetInnerHTML={{ __html: props.period2Label }}
            />
          </Grid>
        </Grid>
      </div>

      <div
        className={props.classes.chart}
        style={
          props.chartMaximized
            ? {
                width: '100vh',
                height: '100vw',
                paddingTop: 0,
                marginTop: '-100vw',
                transform: 'rotate(90deg)',
                transformOrigin: 'bottom left',
                zIndex: 10,
              }
            : {}
        }>
        {getData() && (
          <BarChart
            redraw={props.chartMaximized}
            options={{
              maintainAspectRatio: false,
              legend: {
                display: false,
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      display: true,
                      beginAtZero: true,
                      fontSize: 10,
                      callback: value => {
                        return value.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' ' + getUnit()
                      },
                    },
                  },
                ],
                xAxes: [
                  {
                    ticks: {
                      display: true,
                      fontSize: getData() && getData().length > 5 ? 6 : 9,
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                      callback: value => {
                        return value
                          .replace('-', ' ')
                          .replace('  ', ' ')
                          .split(' ')
                      },
                    },
                  },
                ],
              },
              tooltips: {
                enabled: false,
                callbacks: {
                  title: (tooltipItem, data) => {
                    return data.labels[tooltipItem[0].index]
                  },
                  label: tooltipItem => {
                    return tooltipItem.yLabel.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' ' + getUnit()
                  },
                },
              },
            }}
            data={getChartData()}
          />
        )}

        <img
          src={props.chartMaximized ? exitFullScreenIcon : fullScreenIcon}
          onClick={props.chartMaximized ? props.minimizeChart : props.maximizeChart}
          className={props.classes.maximizeChart}
          style={props.chartMaximized ? { top: 10 } : {}}
        />
      </div>

      <div className={props.classes.menu}>
        {getData() &&
          getData().map((val, i) => (
            <div key={i} className={props.classes.menuItem}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <img src={productIcon} className={props.classes.menuItemIcon} />
                </Grid>
                <Grid item xs={9} className={props.classes.menuItemInfo}>
                  <Typography className={props.classes.menuItemTitle}>{val.name}</Typography>
                  <Typography
                    className={props.classes.menuItemPeriod1}
                    style={isPeriodComparison() ? { background: '#6F95D1' } : { background: getLightColorByIndex(i) }}>
                    {val.period1.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' ' + getUnit()}
                  </Typography>
                  {val.period2 !== null && (
                    <Typography className={props.classes.menuItemPeriod2}>
                      {val.period2.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' ' + getUnit()}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </div>
          ))}
      </div>
    </Page>
  )
}

const styles = {
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  filters,
  filterPeriod1: {
    padding: '5px 0',
    background: '#6F95D1',
  },
  filterPeriod2: {
    padding: '5px 0',
    background: '#8ACA4C',
  },
  icon: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
  filterName: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 300,
    fontSize: 13,
  },
  filterValue: {
    marginTop: -3,
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
  },
  chart: {
    padding: '10px 0',
    height: 250,
    background: 'white',
    borderBottom: '2px solid #777',
  },
  maximizeChart: {
    display: 'none',
    position: 'absolute',
    top: 60,
    right: 10,
    width: 20,
  },
  menu: {},
  menuItem: {
    padding: 10,
    borderBottom: '1px solid #DDD',
    textAlign: 'center',
  },
  menuItemIcon: {
    maxWidth: '50%',
    maxHeight: 30,
  },
  menuItemInfo: {
    textAlign: 'left',
  },
  menuItemTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    textAlign: 'left',
  },
  menuItemPeriod1: {
    display: 'inline-block',
    padding: '0 5px',
    borderRadius: 3,
    background: primaryColor,
    fontSize: 18,
    color: 'white',
  },
  menuItemPeriod2: {
    display: 'inline-block',
    padding: '0 5px',
    borderRadius: 3,
    background: '#8ACA4C',
    fontSize: 18,
    marginLeft: 5,
    color: 'white',
  },
  menuItemBody: {
    fontSize: 12,
    textAlign: 'left',
  },
}

export default withStyles(styles)(StatsByGreenhouseScreen)



// WEBPACK FOOTER //
// ./src/screens/StatsByProductAveragePriceScreen.js